module.exports = __webpack_public_path__ + "img/recommend.f0b800fa.png";